import React from "react";
import FeaturedProducts from "components/FeaturedProducts";
import FaqSplash from "components/Faq/faqSplash";
import Partners from "components/Partners";
import HeadTags from "components/HeadTags";
import CategoryBrowser from "./components/CategoryBrowser";
import Hero from "./components/Hero";

const Home = () => {
  return (
    <>
      <HeadTags />
      <div className="homepagebody">
        <Hero />
        <CategoryBrowser />
        <FeaturedProducts title="New Products" endpoint="new" />
        <FeaturedProducts title="Trending Products" endpoint="trending" />
        <Partners homepage />
        <FaqSplash />
      </div>
    </>
  );
};

export default Home;
